import React from "react";
import {
  Modal,
  Pressable,
  View,
  Text,
  Linking,
  StyleSheet,
} from "react-native";
import WhatsappDefault from "@assets/svg/WhatsappDefault";
import Phone1 from "@assets/svg/Phone1";
import Phone2 from "@assets/svg/Phone2";
import analytics from "@services/analytics";
import { MAP_VIEW_EVENTS } from "@constants/analyticsEventsCT";
import { setItem } from "@lib/storage";
import { contactAllowedCardTypes } from "./constants";

interface ContactOptionProps {
  contactOption: string | null;
  selectedMarker: any;
  setContactOption: (option: any) => void;
  isRescheduledCp: boolean;
  storageKey: string;
  createCall: (
    phone: string,
    cx_id?: string,
    route_id?: string,
    callmatic_mode?: string,
  ) => Promise<void>;
}

const PhoneOptions = ({
  selectedMarker,
  storageKey,
  isRescheduledCp,
  createCall,
}: {
  selectedMarker: any;
  storageKey: string;
  isRescheduledCp: boolean;
  createCall: (
    phone: string,
    cx_id?: string,
    route_id?: string,
    callmatic_mode?: string,
  ) => Promise<void>;
}) => (
  <>
    <View style={styles.header}>
      <Text style={styles.headerText}>Call</Text>
    </View>
    <View style={styles.optionContainer}>
      <Pressable
        style={styles.optionButton}
        onPress={async () => {
          if (selectedMarker?.user_id && isRescheduledCp) {
            if (
              contactAllowedCardTypes.includes(selectedMarker.card_type) ||
              selectedMarker?.action
            ) {
              await createCall(
                selectedMarker?.phone_number_1,
                selectedMarker?.user_id,
                selectedMarker?.route_id,
                selectedMarker?.callmatic_mode,
              );
              return;
            }
            analytics.trackEvent(MAP_VIEW_EVENTS.MAP_CALL_BTN_PRESS, {
              cx_id: selectedMarker.user_id,
            });
            await setItem(
              storageKey,
              JSON.stringify({
                cx_id: selectedMarker.user_id,
                action: "phone",
                cx_phone: selectedMarker?.phone_number_1,
                created_at: new Date(),
              }),
            );
            await createCall(
              selectedMarker?.phone_number_1,
              selectedMarker?.user_id,
              selectedMarker?.route_id,
              selectedMarker?.callmatic_mode,
            );
          } else {
            await createCall(
              selectedMarker?.phone_number_1,
              selectedMarker?.user_id,
              selectedMarker?.route_id,
              selectedMarker?.callmatic_mode,
            );
          }
        }}
      >
        <Phone1 />
        <Text> Phone 1</Text>
      </Pressable>
      {selectedMarker?.phone_number_2 && (
        <Pressable
          style={[styles.optionButton, styles.optionButtonMargin]}
          onPress={async () => {
            if (selectedMarker?.user_id && isRescheduledCp) {
              if (
                contactAllowedCardTypes.includes(selectedMarker.card_type) ||
                selectedMarker?.action
              ) {
                await createCall(
                  selectedMarker?.phone_number_2,
                  selectedMarker?.user_id,
                  selectedMarker?.route_id,
                  selectedMarker?.callmatic_mode,
                );
                return;
              }
              analytics.trackEvent(MAP_VIEW_EVENTS.MAP_CALL_BTN_PRESS, {
                cx_id: selectedMarker.user_id,
              });
              await setItem(
                storageKey,
                JSON.stringify({
                  cx_id: selectedMarker.user_id,
                  action: "phone",
                  cx_phone: selectedMarker?.phone_number_2,
                  created_at: new Date(),
                }),
              );
              await createCall(
                selectedMarker?.phone_number_2,
                selectedMarker?.user_id,
                selectedMarker?.route_id,
                selectedMarker?.callmatic_mode,
              );
            } else {
              await createCall(
                selectedMarker?.phone_number_2,
                selectedMarker?.user_id,
                selectedMarker?.route_id,
                selectedMarker?.callmatic_mode,
              );
            }
          }}
        >
          <Phone2 />
          <Text> Phone 2</Text>
        </Pressable>
      )}
    </View>
  </>
);

const WhatsappOptions = ({
  selectedMarker,
  storageKey,
  isRescheduledCp,
}: {
  selectedMarker: any;
  storageKey: string;
  isRescheduledCp: boolean;
}) => (
  <>
    <View style={styles.header}>
      <Text style={styles.headerText}>Whatsapp</Text>
    </View>
    <View style={styles.optionContainer}>
      <Pressable
        style={styles.optionButton}
        onPress={async () => {
          try {
            if (selectedMarker?.user_id && isRescheduledCp) {
              if (
                contactAllowedCardTypes.includes(selectedMarker.card_type) ||
                selectedMarker?.action
              ) {
                const url = `whatsapp://send?phone=+91${selectedMarker?.phone_number_1}`;
                Linking.canOpenURL(url).then(await Linking.openURL(url));
                return;
              }
              analytics.trackEvent(MAP_VIEW_EVENTS.MAP_WHATSAPP_BTN_PRESS, {
                cx_id: selectedMarker.user_id,
              });
              await setItem(
                storageKey,
                JSON.stringify({
                  cx_id: selectedMarker.user_id,
                  action: "wa",
                  cx_phone: selectedMarker?.phone_number_1,
                  created_at: new Date(),
                }),
              );
              await Linking.openURL(
                `whatsapp://send?phone=+91${selectedMarker?.phone_number_1}`,
              );
            } else {
              await Linking.openURL(
                `whatsapp://send?phone=+91${selectedMarker?.phone_number_1}`,
              );
            }
          } catch (err) {
            Linking.openURL("market://details?id=com.whatsapp");
          }
        }}
      >
        <WhatsappDefault height={25} width={25} />
        <Text> Phone 1</Text>
      </Pressable>
      {selectedMarker?.phone_number_2 && (
        <Pressable
          style={[styles.optionButton, styles.optionButtonMargin]}
          onPress={async () => {
            try {
              if (selectedMarker?.user_id && isRescheduledCp) {
                if (
                  contactAllowedCardTypes.includes(selectedMarker.card_type) ||
                  selectedMarker?.action
                ) {
                  const url = `whatsapp://send?phone=+91${selectedMarker?.phone_number_2}`;
                  Linking.canOpenURL(url).then(await Linking.openURL(url));
                  return;
                }
                analytics.trackEvent(MAP_VIEW_EVENTS.MAP_WHATSAPP_BTN_PRESS, {
                  cx_id: selectedMarker.user_id,
                });
                await setItem(
                  storageKey,
                  JSON.stringify({
                    cx_id: selectedMarker.user_id,
                    action: "wa",
                    cx_phone: selectedMarker?.phone_number_2,
                    created_at: new Date(),
                  }),
                );
                await Linking.openURL(
                  `whatsapp://send?phone=+91${selectedMarker?.phone_number_2}`,
                );
              } else {
                await Linking.openURL(
                  `whatsapp://send?phone=+91${selectedMarker?.phone_number_2}`,
                );
              }
            } catch (err) {
              Linking.openURL("market://details?id=com.whatsapp");
            }
          }}
        >
          <WhatsappDefault height={25} width={25} />
          <Text> Phone 2</Text>
        </Pressable>
      )}
    </View>
  </>
);

const ContactModal = ({
  contactOption,
  selectedMarker,
  setContactOption,
  isRescheduledCp,
  storageKey,
  createCall,
}: ContactOptionProps) => (
  <Modal
    transparent={true}
    visible={!!contactOption}
    statusBarTranslucent
    navigationBarTranslucent
  >
    <Pressable
      style={styles.modalBackground}
      onPress={() => setContactOption(null)}
    >
      <Pressable style={styles.modalContent}>
        {contactOption === "phone" && (
          <PhoneOptions
            selectedMarker={selectedMarker}
            storageKey={storageKey}
            isRescheduledCp={isRescheduledCp}
            createCall={createCall}
          />
        )}
        {contactOption === "wa" && (
          <WhatsappOptions
            selectedMarker={selectedMarker}
            storageKey={storageKey}
            isRescheduledCp={isRescheduledCp}
          />
        )}
      </Pressable>
    </Pressable>
  </Modal>
);

export default ContactModal;

const styles = StyleSheet.create({
  modalBackground: {
    backgroundColor: "rgba(0,0,0,0.2)",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    padding: 20,
    borderRadius: 10,
    backgroundColor: "white",
  },
  header: {
    alignItems: "center",
  },
  headerText: {
    fontSize: 18,
    fontWeight: "bold",
  },
  optionContainer: {
    flexDirection: "row",
    marginTop: 15,
  },
  optionButton: {
    borderWidth: 1,
    borderColor: "rgba(226, 226, 226, 1)",
    padding: 10,
    borderRadius: 15,
    flexDirection: "row",
    alignItems: "center",
  },
  optionButtonMargin: {
    marginLeft: 20,
  },
});
